export default "__VITE_ASSET__daff6255__"